<template>
  <div class="mainHeader">
    <!--  :style="$route.name != 'studyway' ? 'box-shadow:0 2px 10px 0  rgba(0,0,0,.11);' : ''" -->
    <div class="nav">
      <!-- 学习之旅页面展示白色图标 -->
      <!-- <img v-if="$route.name == 'studyway'" src="../../assets/images/student/backhome.png" alt="" width="50" @click="$router.replace({path:'/home'})"> -->
      <!-- 其他页面展示蓝色图标 -->
      <img src="../../assets/images/student/bluebackhome.png" alt="" width="50"
           @click="$router.replace({path:'/home'})">

      <i class="el-icon-arrow-right" :style="$route.name == 'studyway' ?'color:#fff;' : 'color:#333;'"></i>

      <div class="text" v-for="(item,index) in header_data" :key="index"
           :style="$route.name != 'studyway' ? 'color:#333;' : 'color:#fff;'">
        <span class="span-text" @click="back(item,index)">{{ item.title }}</span>
        <span class="span">-</span>
      </div>
    </div>
    <div class="Right">
      <!-- 学习之旅页面展示白色图标 -->
      <div class="main" v-if="$route.name == 'studyway'">
        <el-dropdown trigger="click" @command="returnLogin" :hide-on-click="false">
          <div class="el-dropdown-link">
            <img src="../../assets/images/student/mine.png" alt="">
            <span>
              {{ $store.state.userInfo.realname }} <i class="el-icon-caret-bottom el-icon--right"></i>
            </span>
          </div>
          <template>
            <el-dropdown-menu>
              <el-dropdown-item command="20">设置</el-dropdown-item>
              <el-dropdown-item command="10">退出登录</el-dropdown-item>
              <el-dropdown-item command="0">刷新页面</el-dropdown-item>
              <el-dropdown-item command="5">内核测试</el-dropdown-item>
              <el-dropdown-item command="1">高速通道</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
      <!-- 其他页面展示蓝色图标 -->
      <div class="applcationmain" v-else>
        <el-dropdown trigger="click" @command="returnLogin" :hide-on-click="false">
          <div class="el-dropdown-link">
            <img src="../../assets/images/student/bluemine.png" alt="">
            <span>
              {{ $store.state.userInfo.realname }} <i class="el-icon-caret-bottom el-icon--right"></i>
            </span>
          </div>
          <template>
            <el-dropdown-menu>
              <el-dropdown-item command="20">设置</el-dropdown-item>
              <el-dropdown-item command="10">退出登录</el-dropdown-item>
              <el-dropdown-item command="0">刷新页面</el-dropdown-item>
              <el-dropdown-item command="5">内核测试</el-dropdown-item>
              <el-dropdown-item command="1">高速通道</el-dropdown-item>

            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
      <div class="selectBb" v-if="$route.name == 'books' ">
        <el-dropdown trigger="click" @command="changeBb">
          <el-button type="primary">
            {{ bb.bbmc }}<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
                v-for="data in bbList"
                :key="data.bbid"
                :disabled="data.bbmc === bb.bbmc"
                :command="data"
            >{{ data.bbmc }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="selectBb" v-if="$route.name == 'afterBooks' ">
        <el-dropdown trigger="click" @command="changeBbAfter">
          <el-button type="primary">
            {{ bb.bbmc }}<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
                v-for="data in bbList"
                :key="data.bbid"
                :disabled="data.bbmc === bb.bbmc"
                :command="data"
            >{{ data.bbmc }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <Exitpopup :exit_data="exit_data"/>
<!--    <WordTitle/>-->
  </div>
</template>

<script>
import {browserUrl} from '@/utils/index.js'

export default {
  components: {
    Exitpopup: (resolve) => {
      require(['@/components/student/exitpopup.vue'], resolve)
    },
    // WordTitle: (resolve) => {
    //   require(['@/components/title/title.vue'], resolve)
    // },
  },
  name: 'mainHeader',
  props: {
    header_data: {
      type: Array
    },
    bbid: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      bbList: [{bbid: '', bbmc: ''}],
      bb: {},
      browserUrl: browserUrl, // 退出登陆地址
      exit_data: { // 控制退出登录弹窗显示隐藏
        isShow: false
      }
    }
  },
  methods: {
    // 退出登录
    returnLogin(command) {
      if (command == 10) {
        // 退出登录
        this.exit_data.isShow = true
      } else if (command == 20) {
        this.$router.replace({path: '/setUpPage/information'})
      } else if (command == 5) {
        window.open('https://liulanmi.com/labs/core.html', '_blank');
      } else if (command == 1){
        window.open('https://debugtbs.qq.com', '_blank');
      }else{
        window.location.reload();
      }
    },
    back(val, index) {
      // 面包屑最后一个禁止点击
      if (index == this.header_data.length - 1) {
        return
      }
      this.$router.replace({path: val.path})
    },
    changeBb(data) {
      this.$router.replace({name: 'books', query: {type: this.$route.query.type, bbid: data.bbid, lxid: this.$route.query.lxid}})
    },
    changeBbAfter(data) {
      this.$router.replace({name: 'afterBooks', query: {type: this.$route.query.type, bbid: data.bbid, lxid: this.$route.query.lxid}})
    }
  },
  mounted() {
  },
  watch: {
    bbid(newV, oldV) {
      this.bbList = JSON.parse(sessionStorage.getItem('bbInfo'))
      this.bbList.forEach((ele) => {
        if (ele.bbid === newV) {
          this.bb = ele
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.mainHeader {
  height: 90px;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1999;
}

.Right {
  position: absolute;
  top: 23px;
  right: 40px;
  overflow: hidden;

  .selectBb {
    float: right;
    padding-right: 30px;
  }
}

.main {
  float: right;
  color: #fff;
  font-size: 26px;
  cursor: pointer;
  line-height: 50px;
  animation-delay: 0.6s;
  letter-spacing: 2px;
  position: relative;

  img {
    display: block;
    width: 50px;
    height: 50px;
    float: left;
  }

  span {
    display: block;
    float: left;
    margin-left: 10px;
  }
}

.applcationmain {
  float: right;
  color: #333;
  font-size: 26px;
  cursor: pointer;
  line-height: 50px;
  animation-delay: 0.6s;
  letter-spacing: 2px;
  position: relative;

  img {
    display: block;
    width: 50px;
    height: 50px;
    float: left;
  }

  span {
    display: block;
    float: left;
    margin-left: 10px;
  }
}

.main {
  .el-dropdown {
    color: #fff;
    font-size: 24px;
  }
}

.applcationmain {
  .el-dropdown {
    color: #333;
    font-size: 24px;
  }
}

.nav {
  position: absolute;
  top: 23px;
  left: 40px;
  overflow: hidden;
  color: #fff;

  img {
    display: block;
    float: left;
    cursor: pointer;
  }

  i {
    float: left;
    font-size: 24px;
    line-height: 50px;
    padding: 0 15px;
  }

  .text {
    float: left;
    line-height: 50px;
    font-size: 24px;
    letter-spacing: 3px;
  }
}

.border {
  border-bottom: 1px solid red;
}

.text:last-child {
  .span {
    display: none;
  }
}

.span-text {
  cursor: pointer;
}
/* ========== 手机端适配样式 ========== */
@media screen and (max-width: 1024px) {
  .mainHeader {
    height: 60px;
  }

  .nav {
    top: 12px;
    left: 15px;

    img {
      width: 30px;
    }

    i {
      font-size: 16px;
      line-height: 36px;
      padding: 0 8px;
    }

    .text {
      line-height: 36px;
      font-size: 14px;
      letter-spacing: 1px;
    }
  }

  .Right {
    top: 12px;
    right: 15px;

    .selectBb {
      padding-right: 10px;

      :deep(.el-button--primary) {
        font-size: 12px;
        padding: 6px 12px;
        line-height: 1.2;
      }
    }
  }

  .main,
  .applcationmain {
    font-size: 14px;
    line-height: 36px;

    img {
      width: 30px;
      height: 30px;
    }

    span {
      margin-left: 6px;
      font-size: 14px;
    }

    :deep(.el-dropdown) {
      font-size: 14px;
    }
  }
}
</style>
<style lang="scss">
.mainHeader {
  .el-icon--right {
    display: none;
  }

  .el-button--primary {
    background: #fff;
    border-color: #2ecbff;
    color: #333;
    box-shadow: 0px 0px 8px #2ecbff;
    border-radius: 30px;
    font-size: 1.2rem;
    line-height: 1.5rem;
  }
}
@media screen and (max-width: 768px) {
  .mainHeader {
    .el-button--primary {
      font-size: 12px;
      padding: 5px 12px;
    }
  }
}
/* 平板端版本下拉字号调小 */
@media screen and (min-width: 769px) and (max-width: 1366px) {
  .mainHeader {
    .selectBb .el-button--primary {
      font-size: 16px;
      line-height: 1.3;
      padding: 6px 16px;
    }
  }
}
</style>
